// Turks (tr-TR), groeiSchoolApp: zelfde vorm als groeiSchoolApp.nl.ts (golf 3-integratie). Toon: geen
// oordeel over een kind. Nederlandse schoolnamen (AVI, Cito, vmbo, havo, vwo, groep) blijven staan:
// zo staan ze op het rapport. De toestemmingstekst valt onder GROWTH_CONSENT_TEXT_HASHES (alle talen).
export const appGrowthTr = {
    title: 'Büyüme',
    intro: 'Çocuklarının boyu ve kilosu, sakin bir büyüme eğrisinde. Bunu yalnızca ebeveynler görür. Tablette görünmez; ancak bir ebeveyn bunu bir tablet için kendisi açıkça onaylarsa görünür ve her zaman kaldırılabilir.',
    tab: 'Büyüme',
    empty: 'Henüz ölçüm yok. Örneğin çocuk sağlığı merkezinden (consultatiebureau veya JGZ) sonra ölçün.',
    measurements: '{count} ölçüm',
    measurementsOne: '1 ölçüm',
    lastOn: 'Son ölçüm: {date}',
    open: 'Büyüme: {name}',
    noConsentYet: 'Henüz açılmadı',
    noMeasurements: 'Henüz ölçüm yok',
    consent: {
        version: '2026-10-08.1',
        title: '{name} için büyüme takibi yapılsın mı?',
        parental: {
            text: 'Boy ve kilo sağlık verileridir. Bunları yalnızca {name} adlı çocuğun büyümesini bir grafikte göstermek için saklarız.\nBüyüme eğrisi için bir referans grubu seçersen (Hollanda’daki Türk, Fas veya Hindustani (Surinam) kökenli çocuklar), bu seçimi de saklarız. Bu seçim köken hakkında bir şey söyler.\n{name} erken doğduysa, doğumdaki gebelik süresini girebilirsin. Bu da bir sağlık verisidir.\nBunu yalnızca bu ailedeki ebeveynler görür. Çocuklar için asla ve bağlı akrabalar için asla. Tablette görünmez; ancak bir ebeveyn bunu bir tablet için kendisi açıkça onaylarsa görünür ve her zaman kaldırılabilir.\nHer şeyi indirebilirsin. İzni geri çekmek {name} için tüm ölçümleri ve seçimleri hemen siler; yedeklerden 90 gün içinde kaybolur.\nÇizgiler bir yardımcı araçtır, bir yargı veya teşhis değildir. Emin değilsen consultatiebureau veya JGZ’ye sor.\nBu verilerden AMUMIN B.V. sorumludur. Haklarını gizlilik bildiriminde bulabilirsin.',
            check: '{name} adlı çocuğun ebeveyniyim ({name} 16 yaşından küçük) ve boyunun, kilosunun ve büyüme eğrisi seçimlerinin takip edilmesine izin veriyorum.',
        },
        self: {
            text: 'Boy ve kilo sağlık verileridir. Bunları yalnızca senin büyümeni bir grafikte göstermek için saklarız.\nBüyüme eğrin için bir referans grubu seçilirse (örneğin Hollanda’daki Türk, Fas veya Hindustani (Surinam) kökenli), bu seçimi de saklarız. Bu seçim köken hakkında bir şey söyler. Erken doğduysan doğumundaki gebelik süresi için de aynısı geçerlidir: bu bir sağlık verisidir.\nBunu yalnızca bu ailedeki ebeveynler görür (yani diğer ebeveyn de). Çocuklar için asla ve bağlı akrabalar için asla. Tablette görünmez; ancak bir ebeveyn bunu bir tablet için kendisi açıkça onaylarsa görünür ve her zaman kaldırılabilir.\nHer şeyi indirebilirsin. İzni geri çekmek tüm ölçümlerini ve seçimlerini hemen siler; yedeklerden 90 gün içinde kaybolur.\nBu verilerden AMUMIN B.V. sorumludur. Haklarını gizlilik bildiriminde bulabilirsin.',
            check: 'Kendi boyumun, kilomun ve büyüme eğrisi seçimlerimin takip edilmesine izin veriyorum.',
        },
        /**
         * Aanvulling (0051, tekst 2026-09-28.1): gevraagd op het moment dat een ouder een keuze maakt
         * die een oudere toestemming niet noemde (hs_nl, zwangerschapsduur; bij `self` elke groep
         * behalve nl). De aanvulling noemt altijd ALLE keuzes die die tekst toevoegt (groep en
         * zwangerschapsduur), ook als de ouder er nu maar één kiest: dan dekt ze ze ook echt (review
         * gpl-reg r1). Hoort bij dezelfde hash als parental en self.
         */
        extension: {
            title: 'Bu seçimler için izin',
            intro: '{name} için Büyüme’ye zaten izin verdin. O zamanki metin, şimdi seçebileceğin her şeyden henüz bahsetmiyordu. Bu yüzden, şimdi yalnızca birini seçsen bile, bu iki seçim için ayrıca izin istiyoruz:',
            group: 'Çizgiler için bir referans grubu, örneğin Hollanda’daki Türk, Fas veya Hindustani (Surinam) kökeni. Bu seçim köken hakkında bir şey söyler: bu özel nitelikli bir kişisel veridir.',
            gestation: '{name} erken doğduysa doğumdaki gebelik süresi (22 ile 36 hafta arası). Bu bir sağlık verisidir.',
            rest: 'Bunu yalnızca grafikteki çizgiler için kullanırız. Bunu yalnızca bu ailedeki ebeveynler görür. Tablette görünmez; ancak bir ebeveyn bunu bir tablet için kendisi açıkça onaylarsa görünür ve her zaman kaldırılabilir. İzni geri çekmek bunu ölçümlerle birlikte hemen siler. Çizgiler bir yargı veya teşhis değildir.\nBu izinle {name} için Büyüme izninin en yeni metni geçerli olur.',
            check: '{name} için bu seçimlerin saklanmasına izin veriyorum.',
            selfText: 'Ebeveynlerin büyüme eğrin için bir referans grubu seçebilir (örneğin Hollanda’daki Türk, Fas veya Hindustani (Surinam) kökenli). Bu, köken hakkında bir şey söyler. Erken doğduysan doğumundaki gebelik süresini de girebilirler: bu bir sağlık verisidir. İkisi için de senin iznin gerekir.',
            selfCheck: 'Kendi büyüme eğrim için bu seçimlerin saklanmasına izin veriyorum.',
            give: 'İzin ver ve kaydet',
            giveSelf: 'İzin ver',
            needsOwn: 'Buna {name} kendisi karar verir: {name} kendi uygulamasında Büyüme bölümünden izin verebilir.',
            selfTitle: 'İznin, yeni metinle',
            extended: '{date} tarihinde en yeni metinle tamamlandı.',
        },
        give: 'İzin ver',
        privacyLink: 'Gizlilik bildirimini oku',
        notNow: 'Şimdi değil',
        needsOwn: '{name} için izni yalnızca {name} kendisi, kendi girişiyle verebilir.',
        needsOwnTeen: '16 yaşından itibaren {name} kendisi karar verir. Kendi girişiyle {name}, Büyüme bölümünde izni kendisi verebilir; sonra ölçümleri girebilirsin.',
        lapsed: '{name} artık 16 yaşında ve kendisi karar veriyor. Ölçümleri hâlâ görebilir, indirebilir veya silebilirsin, ama yenisini ekleyemezsin.',
        given: 'İzin verildi: {date}',
        givenSelf: 'İzni kendin verdin: {date}',
        givenByThem: '{name} izni kendisi verdi: {date}',
        withdraw: 'İzni geri çek ve her şeyi sil',
        withdrawTitle: 'İzin geri çekilsin mi?',
        withdrawBody: '{name} adlı çocuğun tüm ölçümleri ve büyüme eğrisi seçimi hemen silinir. Bu geri alınamaz.',
        withdrawConfirm: 'Geri çek ve sil',
        withdrawn: 'İzin geri çekildi. {name} için ölçümler silindi.',
    },
    add: 'Ölçüm ekle',
    edit: 'Ölçümü değiştir',
    date: 'Tarih',
    length: 'Boy (cm)',
    weight: 'Kilo (kg)',
    lengthShort: 'Boy',
    weightShort: 'Kilo',
    bmi: 'VKİ',
    wflShort: 'Kilo/boy',
    note: 'Not (boş kalabilir)',
    notePlaceholder: 'Örneğin: JGZ’de ölçüldü',
    oneOfBoth: 'Boy, kilo veya ikisini birden gir.',
    saved: 'Ölçüm kaydedildi',
    deleted: 'Ölçüm silindi',
    deleteConfirm: 'Bu ölçüm silinsin mi?',
    errors: {
        empty: 'Boy, kilo veya ikisini birden gir.',
        length_range: 'Bu boy doğru değil. Santimetre olarak gir, örneğin 123,5.',
        weight_range: 'Bu kilo doğru değil. Kilogram olarak gir, örneğin 24,5.',
        future: 'Bu tarih gelecekte.',
        before_birth: 'Bu tarih doğum tarihinden önce.',
        note_long: 'Not çok uzun (en fazla 200 karakter).',
        format: 'Virgülden sonra en fazla bir rakam kullan.',
    },
    chart: {
        length: 'Yaşa göre boy',
        weight: 'Yaşa göre kilo',
        bmi: 'Yaşa göre VKİ',
        wfl: 'Boya göre kilo',
        bmiFrom2: 'VKİ’yi 2 yaşından itibaren gösteriyoruz.',
        age: 'Yaş (yıl)',
        date: 'Tarih',
        median: 'Orta (ortalama)',
        sd1: '−1 ve +1 SS',
        sd2: '−2 ve +2 SS',
        you: '{name}',
        lastPoint: 'Son ölçüm: {value}, {date}',
        info: 'Çizgiler bir yardımcı araçtır, bir yargı veya teşhis değildir. Emin değilsen consultatiebureau veya JGZ’ye sor.',
        gaps: {
            no_sex: 'Büyüme çizgilerini görmek için aşağıda erkek veya kız seç.',
            no_group: 'Büyüme çizgilerini görmek için aşağıda bir referans grubu seç. Seçim yapmazsan yalnızca ölçümleri görürsün.',
            no_birth_date: 'Yaşa göre büyümeyi görmek için doğum tarihini gir.',
        },
        source: 'Çizgilerin kaynağı: {source}',
        sources: {
            schonbeck_2011: 'Hollandalı çocuklar, 2009 ({cite})',
            tno_2010: 'Hollandalı çocuklar, 2009 ({cite})',
            tno_2010_origin: 'Hollanda’daki {group} çocuklar, 2009 ({cite})',
            fredriks_2000: 'Hollandalı çocuklar, 1997 ({cite})',
            fredriks_2003: 'Hollanda’daki {group} çocuklar, 1997 ({cite})',
            fredriks_2004: 'Hollanda’daki {group} çocuklar, 1997 ({cite})',
            de_wilde_2014: 'Hollanda’daki {group} çocuklar, 2010 ({cite})',
            de_wilde_2013: 'Hollanda’daki {group} çocuklar, 1976 ({cite})',
            bocca_2012: '{weeks} haftalık doğan çocuklar ({cite})',
            bocca_2012_wfh: 'Erken doğan çocuklar ({cite})',
        },
        citations: {
            schonbeck_2011: 'Schönbeck ve ark., PLoS ONE 2011, CC BY',
            tno_2010: 'TNO, Groeidiagrammen 2010',
            tno_2010_origin: 'TNO, Groeidiagrammen 2010',
            fredriks_2000: 'TNO, Fredriks ve ark. 2000',
            fredriks_2003: 'TNO, Fredriks ve ark. 2003',
            fredriks_2004: 'TNO, Fredriks ve ark. 2004',
            de_wilde_2014: 'TNO, de Wilde ve ark. 2014',
            de_wilde_2013: 'TNO, de Wilde ve ark. 2013',
            bocca_2012: 'TNO, Bocca-Tjeertes ve ark. 2012',
            bocca_2012_wfh: 'TNO, Bocca-Tjeertes ve ark. 2012',
        },
        /** Golf 19: welke lijnen waar gelden (een tabel per stuk, zie referenceSegments). */
        rangeUntil: '{age} yaşına kadar:',
        rangeBetween: '{from}-{to} yaş:',
        rangeFrom: '{age} yaşından itibaren:',
        sourceJoin: '; ',
        switchNote: '{age} yaşında çizgiler başka bir tabloya geçer (aşağıdaki kaynağa bak). Orada biraz sıçrayabilirler.',
        pretermNote: '{age} yaşına kadar {weeks} haftalık doğan çocukların çizgilerini, doğumdan itibaren geçen yaşa göre görürsün. Sonrasında normal çizgiler.',
        pretermWflNote: '{age} yaşına kadar burada erken doğan çocukların çizgilerini görürsün. Sonrasında normal çizgiler.',
        table: 'Tüm ölçümlerin tablosu',
        showTable: 'Tablo olarak göster',
        showChart: 'Grafik olarak göster',
    },
    settings: {
        title: 'Büyüme eğrisi',
        sex: 'Cinsiyet (çizgiler için)',
        sexUnset: 'Seçilmedi',
        female: 'Kız',
        male: 'Erkek',
        group: 'Referans grubu',
        groupHint: 'Yalnızca grafikteki çizgiler için. En uygun olanı seç; her zaman değiştirebilir veya boş bırakabilirsin.',
        groups: {
            none: 'Yok (yalnızca ölçümler)',
            nl: 'Hollandalı çocuklar',
            tr_nl: 'Hollanda’daki Türk kökenli çocuklar',
            ma_nl: 'Hollanda’daki Fas kökenli çocuklar',
            hs_nl: 'Hollanda’daki Hindustani (Surinam) kökenli çocuklar',
        },
        groupNames: {
            nl: 'Hollandalı',
            tr_nl: 'Türk kökenli',
            ma_nl: 'Fas kökenli',
            hs_nl: 'Hindustani (Surinam) kökenli',
        },
        /** Golf 19: neutrale uitleg bij de groepen en de zwangerschapsduur (alleen te vroeg). */
        groupInfo: 'Her grubun çizgileri, Hollanda’da o kökenden çocuklarla yapılan araştırmalardan gelir. Hindustani (Surinam), çoğu zaman Surinam üzerinden gelen, Güney Asyalı ataları olan çocuklar demektir. Her grubun her ölçü için kendi çizgileri yoktur; hangi çizgileri gördüğün grafiğin altında yazar.',
        gestation: 'Doğumdaki gebelik süresi',
        gestationNone: 'Zamanında doğdu (veya girilmedi)',
        gestationWeeks: '{weeks} hafta',
        gestationHint: 'Yalnızca {name} erken doğduysa doldur ({term}. haftadan önce). O zaman {age} yaşına kadar erken doğan çocukların çizgilerini görürsün; {min}-{max} hafta için bunlar {table} haftanın çizgileridir. Bu bir sağlık bilgisidir: ölçümlerle aynı izne tabidir, yalnızca ebeveynler görür ve izni geri çekmek bunu da siler.',
        saved: 'Kaydedildi',
    },
    birthDate: 'Doğum tarihi: {name}',
    birthDateHint: 'Yaşa göre büyüme için gerekli. Doğum günleri bölümünde de görünür.',
    download: 'İndir',
    downloadCsv: 'Tablo olarak (CSV)',
    downloadJson: 'Her şey (JSON)',
    clear: 'Tüm ölçümleri sil',
    clearTitle: '{name} için tüm ölçümler silinsin mi?',
    clearBody: 'İzin yerinde kalır, böylece yeniden başlayabilirsin. Bu geri alınamaz.',
    cleared: '{name} için tüm ölçümler silindi.',
    privacyNote: 'Bunu yalnızca ebeveynler görür. Tablette görünmez; ancak bir ebeveyn bunu bir tablet için kendisi açıkça onaylarsa görünür ve her zaman kaldırılabilir.',
    selfIntro: 'Boyun ve kilon, sakin bir büyüme eğrisinde. Ölçümleri ailen girer; bunu yalnızca sen ve ailen görürsünüz.',
    selfUnder16: 'Boyunu ve kilonu ailen takip eder. 16 yaşından itibaren buna sen karar verirsin.',
    selfNote: 'Bunu yalnızca sen ve ailen görürsünüz. Tablette görünmez; ancak bir ebeveyn bunu bir tablet için kendisi açıkça onaylarsa görünür ve her zaman kaldırılabilir.',
    /** Kolomkoppen van de CSV-download (review g3-fs r1: in de taal van het gezin). */
    csvHead: ['tarih', 'boy_cm', 'kilo_kg', 'vki', 'not'],
    moduleOff: 'Büyüme, Sağlık modülüne aittir. Bu modül kapalı.',
};
export const appSchoolTr = {
    title: 'Okul',
    intro: 'Her çocuk için karne notları ve sınavlar, sakin bir zaman çizelgesinde. Bunu yalnızca ebeveynler görür; tablette asla.',
    childIntro: 'Karnelerin ve sınavların. Bunları ebeveynlerin girer.',
    childOff: 'Ebeveynlerin bunu senin için henüz açmadı.',
    tab: 'Okul',
    open: 'Okul: {name}',
    noChildren: 'Ailende henüz çocuk yok.',
    empty: 'Henüz bir şey girilmedi. Son karneyle veya bir sınavla başla.',
    nothingYet: 'Henüz bir şey girilmedi',
    count: '{count} sonuç',
    countOne: '1 sonuç',
    add: 'Sonuç ekle',
    edit: 'Sonucu değiştir',
    saved: 'Kaydedildi',
    deleted: 'Silindi',
    deleteConfirm: 'Bu sonuç silinsin mi?',
    timeline: 'Zaman çizelgesi',
    trends: 'Derse göre',
    noTrend: 'İki veya daha fazla sonuç olunca bir çizgi görünür.',
    childView: '{name} bunu kendisi görebilsin mi?',
    childViewHint: 'Yalnızca web uygulamasında kendi girişiyle, yalnızca kendi sonuçları ve yalnızca okuma. Tablette asla.',
    childViewOn: '{name} artık bunu kendisi görebilir.',
    childViewOff: '{name} bunu görmüyor.',
    download: 'İndir',
    downloadCsv: 'Tablo olarak (CSV)',
    downloadJson: 'Her şey (JSON)',
    clear: '{name} için her şeyi sil',
    clearTitle: '{name} için tüm sonuçlar silinsin mi?',
    clearBody: 'Bu geri alınamaz.',
    cleared: '{name} için tüm sonuçlar silindi.',
    field: {
        kind: 'Tür',
        schoolYear: 'Öğretim yılı',
        period: 'Dönem',
        date: 'Tarih (boş kalabilir)',
        group: 'Grup (groep)',
        groupNone: 'Bilinmiyor',
        subject: 'Ders',
        domain: 'Alan',
        scale: 'Ölçek',
        grade: 'Not',
        gradeHint: '1’den 10’a kadar, örneğin 7,5',
        word: 'Değerlendirme',
        level: 'Seviye',
        score: 'Beceri puanı (boş kalabilir)',
        dmtScore: 'Puan (doğru okunan kelime sayısı)',
        provider: 'Sınavı yapan (boş kalabilir)',
        note: 'Not (boş kalabilir)',
    },
    errors: {
        school_year: 'Bir öğretim yılı seç.',
        period: 'Bu türe uyan bir dönem seç.',
        group: '1 ile 8 arasında bir grup seç.',
        subject: 'Bir ders seç.',
        domain: 'Bir alan seç.',
        scale: 'Bir ölçek seç.',
        value: 'Bu değer ölçeğe uymuyor.',
        provider: 'Listeden bir sınav seç.',
        note: 'Not çok uzun (en fazla 200 karakter).',
        future: 'Bu tarih gelecekte.',
        subject_dup: 'Bu ders zaten var.',
    },
    /** Titels van een lijn "Per vak" (review g3-ux r1): rapport en toets nooit dezelfde titel. */
    titles: {
        grade: '{subject} · karne',
        lvs: 'Sınav · {domain}',
    },
    kinds: {
        grade: 'Karne notu',
        lvs: 'Sınav (öğrenci izleme sistemi, LVS)',
        avi: 'AVI okuma seviyesi',
        dmt: 'DMT (Üç Dakika Testi)',
        level: 'İşlev seviyesi (functioneringsniveau)',
        doorstroom: 'Grup 8 geçiş sınavı (doorstroomtoets)',
        advies: 'Okul tavsiyesi (schooladvies)',
    },
    periods: {
        b: 'Başlangıç',
        r1: 'Karne 1',
        m: 'Orta',
        r2: 'Karne 2',
        r3: 'Karne 3',
        e: 'Son',
        r4: 'Karne 4',
        voorlopig: 'Geçici',
        definitief: 'Kesin',
    },
    periodsShort: {
        b: 'Baş',
        r1: 'K1',
        m: 'Ort',
        r2: 'K2',
        r3: 'K3',
        e: 'Son',
        r4: 'K4',
        voorlopig: 'geç.',
        definitief: 'kes.',
    },
    scales: {
        number: 'Not 1-10',
        word: 'Kelimeler (O’dan ZG’ye)',
        roman: 'I’den V’e',
        letter: 'A’dan E’ye',
        ref: '1F / 2F / 1S',
    },
    domains: {
        rekenen: 'Matematik',
        begrijpend_lezen: 'Okuduğunu anlama',
        spelling: 'Yazım',
        technisch_lezen: 'Teknik okuma',
        lezen: 'Okuma',
        taalverzorging: 'Dil bilgisi ve yazım',
    },
    providers: {
        cito: 'Cito (Leerling in beeld)',
        boom: 'Boom LVS',
        iep: 'IEP',
        dia: 'Diatoetsen',
        amn: 'AMN',
        route8: 'ROUTE 8',
        doe: 'DOE-toets',
        other: 'Diğer',
    },
    words: {
        O: 'Yetersiz',
        M: 'Orta',
        V: 'Yeterli',
        RV: 'Yeterlinin üstünde',
        G: 'İyi',
        ZG: 'Çok iyi',
    },
    advice: {
        pro: 'Praktijkonderwijs (uygulamalı eğitim)',
        vmbo_b: 'vmbo basis',
        vmbo_b_k: 'vmbo basis / kader',
        vmbo_k: 'vmbo kader',
        vmbo_k_gt: 'vmbo kader / gt',
        vmbo_gt: 'vmbo gemengd/theoretisch (gt)',
        vmbo_gt_havo: 'vmbo gt / havo',
        havo: 'havo',
        havo_vwo: 'havo / vwo',
        vwo: 'vwo',
    },
    explain: {
        grade: '1’den 10’a kadar bir karne notu. 5,5 veya üstü yeterlidir.',
        word: '{code} = {word}.',
        aviStart: 'AVI-Start = okumayı öğrenmenin başlangıcı, grup 3’te.',
        aviPlus: 'AVI-Plus = en yüksek AVI seviyesi, grup 7 sonundan sonra.',
        avi: 'AVI {code} = grup {group} {moment} okuma seviyesi.',
        level: '{code} = grup {group} {moment} seviye.',
        roman: {
            I: 'I = Hollanda’daki çocukların en yüksek %20’si arasında.',
            II: 'II = ortalamanın biraz üstünde (sonraki %20).',
            III: 'III = ortalama civarında (ortadaki %20).',
            IV: 'IV = ortalamanın biraz altında (sonraki %20).',
            V: 'V = en düşük %20 arasında. Okul o zaman neyin ek olarak yardımcı olacağına bakar.',
        },
        letter: {
            A: 'A = Hollanda’daki çocukların en yüksek %25’i arasında.',
            B: 'B = ortalamanın biraz üstünde (sonraki %25).',
            C: 'C = ortalamanın biraz altında (sonraki %25).',
            D: 'D = ortalamanın epey altında (sonraki %15).',
            E: 'E = en düşük %10 arasında. Okul o zaman neyin ek olarak yardımcı olacağına bakar.',
        },
        ref: {
            '<1F': '1F henüz ulaşılmadı. Bu, grup 8 sonu için temel seviyedir.',
            '1F': '1F = neredeyse tüm çocukların grup 8 sonunda ulaştığı temel seviye.',
            '2F': '2F = grup 8 sonunda okuma ve dil için hedef seviye.',
            '1S': '1S = grup 8 sonunda matematik için hedef seviye.',
        },
        dmt: 'DMT, bir çocuğun üç dakikada kaç tek kelimeyi doğru okuduğunu ölçer.',
        doorstroom: 'Geçiş sınavı (2024’ten beri) okuma, dil bilgisi ve matematiği 1F, 2F ve 1S seviyelerinde ölçer.',
        advies: 'Okul tavsiyesi, hangi tür ortaöğretimin uygun olduğunu söyler.',
        moments: { B: 'başındaki', M: 'ortasındaki', E: 'sonundaki' },
    },
    subjects: {
        title: 'Dersler',
        hint: 'Okulun karnesindeki dersler. Adlarını değiştirebilir veya kaldırabilirsin; eski notlar yerinde kalır.',
        add: 'Ders ekle',
        name: 'Dersin adı',
        suggested: 'Standart dersleri ekle',
        suggestions: [
            'Matematik',
            'Dil',
            'Yazım',
            'Okuma',
            'Okuduğunu anlama',
            'El yazısı',
            'Coğrafya',
            'Tarih',
            'Fen bilgisi',
            'İngilizce',
        ],
        remove: 'Kaldır',
        rename: 'Yeniden adlandır',
        removed: 'Ders kaldırıldı. Eski notlar yerinde kalır.',
        none: 'Henüz ders yok. Ekle veya standart dersleri seç.',
        archived: '{name} (kaldırıldı)',
    },
    /** Kolomkoppen van de CSV-download (review g3-fs r1: in de taal van het gezin). */
    csvHead: [
        'okul_yili',
        'donem',
        'tarih',
        'grup',
        'tur',
        'ders_veya_alan',
        'deger',
        'sinav',
        'not',
    ],
    moduleOff: 'Okul kapalı.',
};
//# sourceMappingURL=groeiSchoolApp.tr.js.map